/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { DataTable, DataTableSortEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { useRef } from "react";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import { PaginatorPageChangeEvent } from "primereact/paginator";
import { ConfirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { AxiosResponse } from "axios";
import Loader from "../../../components/loader";
import PrimePaginator from "../../../components/prime-paginator";
import DeleteConfirmationDialog from "../../../components/delete-confirmation";
import {
    checkActionAuthorization,
    downloadCsvFile,
    IsFormValid,
} from "../../../service/shared.service";
import {
    IsNullOrEmptyArray,
    IsStringNullEmptyOrUndefined,
} from "../../../utils/null-check";
import { toastOptObj } from "../../../utils/constants";
import { APIResponseEntity } from "../../../interface/api-responce";
import { PaginateRespEntity } from "../../../interface";
import {
    APIToGetNamedTrack,
    APIToCreateNamedTrack,
    APIToUpdateNamedTrack,
    APIToDeleteNamedTrack,
    APIToExportNamedTrack,
    APIToGetNamedTrackDDL,
} from "../../../service/api-service";
import {
    NamedTrackDetailsEntity,
    NamedTrackFilterRequest,
    NamedTrackMemberEntity,
    NamedTrackDDLMasterEntity,
} from "../../../interface/production-master";

const Status = [
    { name: "Active", code: true },
    { name: "Inactive", code: false },
];

const CategoryName = {
    WorkCenter: "work_centeres",
    NameTrack: "name_tracks",
};

interface MemberOption {
    label: string;
    value: string;
    categoryName: string;
}

interface MemberGroup {
    label: string;
    items: MemberOption[];
}

function NamedTrack() {
    const masterFilterRef = useRef<any>(null);
    const [status] = useState(["Active", "Inactive"]);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [namedTrackDetails, setNamedTrackDetails] = useState<NamedTrackDetailsEntity[]>([]);
    const [totalPageCount, setTotalPageCount] = useState<number>(0);
    const [filterReq, setFilterReq] = useState<NamedTrackFilterRequest>({
        pageSize: 10,
        pageNumber: 0,
        sortColumn: "createdAt",
        sortOrder: "desc",
        trackerSearchText: "",
        masterTrackerIds: [],
        trackNameSearchText: "",
        status: "",
        APICallCount: 0,
    });
    const [isDeleteRecordId, setIsDeleteRecordId] = useState<string>("");
    const [isDialogVisible, setIsDialogVisible] = useState<boolean>(false);
    const [isEditMode, setIsEditMode] = useState<boolean>(false);
    const [selectedNamedTrackId, setSelectedNamedTrackId] = useState<string>("");
    const [trackCode, setTrackCode] = useState<string>("");
    const [trackName, setTrackName] = useState<string>("");
    const [selectedMasterTrackId, setSelectedMasterTrackId] = useState<string>("");
    const [selectedMembers, setSelectedMembers] = useState<NamedTrackMemberEntity[]>([]);
    const [memberToAdd, setMemberToAdd] = useState<string>("");
    const [namedTrackIsActive, setNamedTrackIsActive] = useState<boolean>(true);
    const [submitted, setSubmitted] = useState<boolean>(false);
    const [formErrors, setFormErrors] = useState({
        code: "Please enter track code",
        name: "Please enter track name",
        masterTrack: "Please select master track",
        members: "Please add at least one member",
    });
    const [ddlMasterTrackers, setDdlMasterTrackers] = useState<NamedTrackDDLMasterEntity[]>([]);
    const [selectedMasterFilters, setSelectedMasterFilters] = useState<string[]>([]);
    const [tempMasterFilters, setTempMasterFilters] = useState<string[]>([]);
    useEffect(() => {
        const delayDebounceFn = setTimeout(async () => {
            await fetchNamedTracks();
        }, 300);
        return () => clearTimeout(delayDebounceFn);
    }, [filterReq]);

    useEffect(() => {
        fetchDropdownOptions();
    }, []);
    const fetchNamedTracks = async (): Promise<void> => {
        setIsLoading(true);
        const reqObj = {
            pageNumber: filterReq.pageNumber,
            pageSize: filterReq.pageSize,
            sortOrder: filterReq.sortOrder,
            sortColumn: filterReq.sortColumn,
            trackerSearchText: filterReq.trackerSearchText,
            masterTrackerIds: filterReq.masterTrackerIds,
            trackNameSearchText: filterReq.trackNameSearchText,
            ...(!IsStringNullEmptyOrUndefined(filterReq.status) && {
                status: filterReq.status,
            }),
        };

        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToGetNamedTrack(reqObj);
            setNamedTrackDetails([]);
            setTotalPageCount(0);
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const paginateResp: PaginateRespEntity = axiosResp.data;
                    setNamedTrackDetails(paginateResp.data);
                    setTotalPageCount(paginateResp.totalCount);
                } else {
                    toast.error(axiosResp?.message || "Unable to get named tracks", { ...toastOptObj, });
                }
            } else {
                toast.error(resp?.data?.message || "Unable to get named tracks", { ...toastOptObj, });
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    const fetchDropdownOptions = async (): Promise<void> => {
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToGetNamedTrackDDL();

            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;

                if (axiosResp && axiosResp.data && axiosResp.statusCode === 200) {
                    setDdlMasterTrackers(axiosResp.data.masterTracker || []);
                }
            }
        } catch (error) {
            toast.error("Unable to get dropdown options", { ...toastOptObj, });
        }
    };

    const masterTrackOptions = ddlMasterTrackers.map((master) => ({
        label: master.code,
        value: master.id,
    }));

    // flat lookup across every master so chips / rows resolve labels in edit mode too
    const memberLabelMap = new Map<string, string>();
    ddlMasterTrackers.forEach((master) => {
        (master.workCenter || []).forEach((wc) => {
            memberLabelMap.set(wc.id, `${wc.code} — ${wc.fullName}`);
        });
        (master.nameTracker || []).forEach((nt) => {
            memberLabelMap.set(nt.id, `${nt.name} (${nt.trackerCode})`);
        });
    });

    const selectedMaster = ddlMasterTrackers.find(
        (master) => master.id === selectedMasterTrackId
    );

    const selectedMemberIds = selectedMembers.map((member) => member.categoryId);

    const memberGroups: MemberGroup[] = [
        {
            label: "Work centres",
            items: (selectedMaster?.workCenter || [])
                .filter((wc) => !selectedMemberIds.includes(wc.id))
                .map((wc) => ({
                    label: `${wc.code} — ${wc.fullName}`,
                    value: wc.id,
                    categoryName: CategoryName.WorkCenter,
                })),
        },
        {
            label: "Named tracks",
            items: (selectedMaster?.nameTracker || [])
                .filter(
                    (nt) =>
                        nt.id !== selectedNamedTrackId &&
                        !selectedMemberIds.includes(nt.id)
                )
                .map((nt) => ({
                    label: `${nt.name} (${nt.trackerCode})`,
                    value: nt.id,
                    categoryName: CategoryName.NameTrack,
                })),
        },
    ].filter((group) => group.items.length > 0);

    const onPageChange = (event: PaginatorPageChangeEvent): void => {
        setFilterReq(prev => ({
            ...prev,
            pageSize: event.rows,
            pageNumber: event.page,
            APICallCount: prev.APICallCount + 1,
        }));
    };

    const onTableSort = (event: DataTableSortEvent): void => {
        if (event && event.sortField && event.sortOrder) {
            setFilterReq(prev => ({
                ...prev,
                sortColumn: event.sortField as string,
                sortOrder: event.sortOrder === 1 ? "asce" : "desc",
                pageNumber: 0,
                APICallCount: prev.APICallCount + 1,
            }));
        }
    };

    const resetFormState = (): void => {
        setSelectedNamedTrackId("");
        setTrackCode("");
        setTrackName("");
        setSelectedMasterTrackId("");
        setSelectedMembers([]);
        setMemberToAdd("");
        setNamedTrackIsActive(true);
        setSubmitted(false);
        setFormErrors({
            code: "Please enter track code",
            name: "Please enter track name",
            masterTrack: "Please select master track",
            members: "Please add at least one member",
        });
    };

    const handleAdd = async (): Promise<void> => {
        setIsEditMode(false);
        resetFormState();
        setIsDialogVisible(true);
    };

    const handleEdit = async (rowData: NamedTrackDetailsEntity): Promise<void> => {
        if (!rowData || IsStringNullEmptyOrUndefined(rowData.id)) {
            return;
        }

        const members = [...(rowData.members || [])].sort(
            (a, b) => (a?.seqNumber ?? 0) - (b?.seqNumber ?? 0)
        );

        setSelectedNamedTrackId(rowData.id);
        setTrackCode(rowData.trackerCode || "");
        setTrackName(rowData.name || "");
        setSelectedMasterTrackId(rowData.masterTrackerId || "");
        setSelectedMembers(members);
        setMemberToAdd("");
        setNamedTrackIsActive(rowData.isActive ?? true);
        setIsEditMode(true);
        setSubmitted(false);
        setFormErrors({
            code: "",
            name: "",
            masterTrack: IsStringNullEmptyOrUndefined(rowData.masterTrackerId || "") ? "Please select master track" : "",
            members: IsNullOrEmptyArray(members) ? "Please add at least one member" : "",
        });
        setIsDialogVisible(true);
    };

    const closeDialog = (): void => {
        setIsDialogVisible(false);
        setIsEditMode(false);
        resetFormState();
    };

    const handleChange = (fieldName: string, value: string): void => {
        switch (fieldName) {
            case "code":
                setTrackCode(value);
                setFormErrors(prev => ({
                    ...prev,
                    code: IsStringNullEmptyOrUndefined(value.trim())
                        ? "Please enter track code"
                        : "",
                }));
                break;

            case "name":
                setTrackName(value);
                setFormErrors(prev => ({
                    ...prev,
                    name: IsStringNullEmptyOrUndefined(value.trim())
                        ? "Please enter track name"
                        : "",
                }));
                break;
            default:
                break;
        }
    };

    const handleMasterTrackChange = (value: string): void => {
        setSelectedMasterTrackId(value);
        // members belong to the selected master — clear them on change
        setSelectedMembers([]);
        setMemberToAdd("");
        setFormErrors(prev => ({
            ...prev,
            masterTrack: IsStringNullEmptyOrUndefined(value) ? "Please select master track" : "",
            members: "Please add at least one member",
        }));
    };

    const addMember = (): void => {
        if (IsStringNullEmptyOrUndefined(memberToAdd)) {
            return;
        }

        const allOptions = memberGroups.flatMap((group) => group.items);
        const option = allOptions.find((item) => item.value === memberToAdd);
        if (!option) {
            return;
        }

        setSelectedMembers(prev => [
            ...prev,
            {
                categoryId: option.value,
                categoryName: option.categoryName,
                seqNumber: prev.length + 1,
            },
        ]);
        setMemberToAdd("");
        setFormErrors(prev => ({ ...prev, members: "" }));
    };

    const removeMember = (index: number): void => {
        setSelectedMembers(prev => {
            const updated = prev
                .filter((_, i) => i !== index)
                .map((member, i) => ({ ...member, seqNumber: i + 1 }));

            setFormErrors(errors => ({
                ...errors,
                members: IsNullOrEmptyArray(updated) ? "Please add at least one member" : "",
            }));

            return updated;
        });
    };

    const handleSaveNamedTrack = async (): Promise<void> => {
        setSubmitted(true);
        const isValid = IsFormValid(formErrors);
        if (
            IsStringNullEmptyOrUndefined(trackCode.trim()) ||
            IsStringNullEmptyOrUndefined(trackName.trim()) ||
            IsStringNullEmptyOrUndefined(selectedMasterTrackId) ||
            IsNullOrEmptyArray(selectedMembers)
        ) {
            return;
        }
        if (!isValid) {
            return;
        }
        setIsLoading(true);
        let resp: AxiosResponse<APIResponseEntity>;
        try {
            const reqObj = {
                trackerCode: trackCode.trim(),
                name: trackName.trim(),
                masterTrackerId: selectedMasterTrackId,
                members: selectedMembers.map((member, index) => ({
                    ...member,
                    seqNumber: index + 1,
                })),
            };
            if (isEditMode) {
                resp = await APIToUpdateNamedTrack(selectedNamedTrackId, {
                    ...reqObj,
                    isActive: namedTrackIsActive,
                });
            } else {
                resp = await APIToCreateNamedTrack(reqObj);
            }
            if (resp && resp.data && (resp.status === 200 || resp.status === 201)) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && (axiosResp.statusCode === 200 || axiosResp.statusCode === 201)) {
                    toast.success(axiosResp.message, { ...toastOptObj, });
                    closeDialog();
                    setFilterReq(prev => ({
                        ...prev, pageNumber: 0, APICallCount: prev.APICallCount + 1,
                    }));
                }
            } else {
                toast.error(resp?.data?.message, { ...toastOptObj, });
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    const deleteNamedTrack = async (value: boolean): Promise<void> => {
        if (!value) {
            return;
        }
        if (IsStringNullEmptyOrUndefined(isDeleteRecordId)) {
            return;
        }
        setIsLoading(true);
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToDeleteNamedTrack(isDeleteRecordId);
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.status && axiosResp.statusCode === 200) {
                    toast.success(axiosResp.message, { ...toastOptObj, });
                    setIsDeleteRecordId("");
                    setFilterReq(prev => ({
                        ...prev,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }));
                } else {
                    toast.error(axiosResp?.message || "Unable to delete named track", { ...toastOptObj, });
                }
            } else {
                toast.error(resp?.data?.message || "Unable to delete named track", { ...toastOptObj, });
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    const fetchNamedTrackCsvDetails = async (): Promise<void> => {
        setIsLoading(true);
        try {
            const resp: AxiosResponse<APIResponseEntity> = await APIToExportNamedTrack();
            if (resp && resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const excelUrl = axiosResp.data.xlsxUrl;
                    if (excelUrl && !IsStringNullEmptyOrUndefined(excelUrl)) {
                        const fileName: string = excelUrl.split("/").pop();
                        if (fileName && !IsStringNullEmptyOrUndefined(fileName)) {
                            await downloadCsvFile(excelUrl, fileName);
                        }
                    }
                }
            } else {
                toast.error(resp?.data?.message, { ...toastOptObj, });
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    const resetFilters = (): void => {
        setSelectedStatus("");
        setSelectedMasterFilters([]);
        setTempMasterFilters([]);
        setFilterReq(prev => ({
            ...prev,
            pageSize: 10,
            pageNumber: 0,
            sortColumn: "createdAt",
            sortOrder: "desc",
            trackerSearchText: "",
            trackNameSearchText: "",
            masterTrackerIds: [],
            status: "",
            APICallCount: prev.APICallCount + 1,
        }));
    };

    const handleChangeStatus = (e: string) => {
        setSelectedStatus(e);
        setFilterReq(prev => ({
            ...prev,
            status: e === "Active" ? "true" : e === "Inactive" ? "false" : "",
            pageNumber: 0,
            APICallCount: prev.APICallCount + 1,
        }));
    };

    const statusBodyTemplate = (rowData: NamedTrackDetailsEntity) => {
        return (
            <span
                className={`badge badge-${rowData.isActive === true ? "success" : "danger"}`}
            >
                {rowData.isActive ? "Active" : "Inactive"}
            </span>
        );
    };

    const statusRowFilterTemplate = () => {
        return (
            <Dropdown
                value={selectedStatus}
                options={status}
                onChange={(e) => { handleChangeStatus(e.value); }}
                placeholder="Select status"
                className="p-column-filter"
                style={{ minWidth: "12rem", }}
            />
        );
    };

    const trackFilterTemplate = () => {
        return (
            <InputText
                value={filterReq.trackerSearchText}
                placeholder="Search by track"
                onChange={(e) =>
                    setFilterReq(prev => ({
                        ...prev,
                        trackerSearchText: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }))
                }
            />
        );
    };

    const nameFilterTemplate = () => {
        return (
            <InputText
                value={filterReq.trackNameSearchText}
                placeholder="Search by name"
                onChange={(e) =>
                    setFilterReq(prev => ({
                        ...prev,
                        trackNameSearchText: e.target.value,
                        pageNumber: 0,
                        APICallCount: prev.APICallCount + 1,
                    }))
                }
            />
        );
    };

    const masterTrackerFilterTemplate = () => {
        return (
            <MultiSelect
                ref={masterFilterRef}
                value={tempMasterFilters}
                options={masterTrackOptions}
                optionLabel="label"
                optionValue="value"
                placeholder="Select master"
                className="p-column-filter"
                maxSelectedLabels={1}
                filter
                resetFilterOnHide
                panelFooterTemplate={() => (
                    <div className="p-2">
                        <button
                            type="button"
                            className="p-button p-component p-button-sm"
                            onClick={() => {
                                setSelectedMasterFilters(tempMasterFilters);

                                setFilterReq(prev => ({
                                    ...prev,
                                    masterTrackerIds: tempMasterFilters,
                                    pageNumber: 0,
                                    APICallCount: prev.APICallCount + 1,
                                }));

                                masterFilterRef.current.hide();
                            }}
                            disabled={
                                JSON.stringify([...tempMasterFilters].sort()) ===
                                JSON.stringify([...selectedMasterFilters].sort())
                            }
                        >
                            Apply
                        </button>
                    </div>
                )}
                onChange={(e) => {
                    setTempMasterFilters(e.value);
                }}
                onHide={() => {
                    setTempMasterFilters(selectedMasterFilters);
                }}
            />
        );
    };

    const membersBodyTemplate = (rowData: NamedTrackDetailsEntity) => (
        <span>
            {!IsStringNullEmptyOrUndefined(rowData.membersDisplay || "")
                ? rowData.membersDisplay
                : "-"}
        </span>
    );

    const actionIconTemplate = (rowData: NamedTrackDetailsEntity) => {
        return (
            <ul className="tableIcon cursor-pointer action-icon-template-w">
                {
                    checkActionAuthorization("update", "Name Track") && (
                        <li
                            data-toggle="tooltip"
                            title="Edit"
                        >
                            <img
                                src="assets/images/edit-icon.svg"
                                alt="Edit"
                                onClick={() => { handleEdit(rowData); }}
                            />
                        </li>
                    )
                }
                {
                    checkActionAuthorization("delete", "Name Track") && (
                        <li
                            data-toggle="tooltip"
                            title="Delete"
                            onClick={() => { setIsDeleteRecordId(rowData.id); }}
                        >
                            <DeleteConfirmationDialog isAccepted={deleteNamedTrack} />
                        </li>
                    )
                }
            </ul>
        );
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            <ConfirmDialog />
            <div className="content-wrapper">
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="card card-rounded">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="row align-items-center">
                                                <div className="col-lg-5 col-md-5 col-12">
                                                    <h4 className="card-title mb-0">
                                                        Named Tracks Master
                                                    </h4>
                                                </div>
                                                <div className="col-lg-7 col-md-7 col-12">
                                                    <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">
                                                        {
                                                            checkActionAuthorization("create", "Name Track") && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-md font-weight-medium"
                                                                    onClick={handleAdd}
                                                                >
                                                                    Add Name Track
                                                                </button>
                                                            )
                                                        }
                                                        {
                                                            checkActionAuthorization("upgrade", "Allow to Export Name Track") && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success btn-md font-weight-medium m-0 me-2"
                                                                    onClick={fetchNamedTrackCsvDetails}
                                                                >
                                                                    Export Name Track
                                                                </button>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end mt-2">
                                                <span
                                                    className="resetFilters text-primary cursor-pointer"
                                                    onClick={resetFilters}
                                                >
                                                    Reset Filters
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col">
                                            <DataTable
                                                value={namedTrackDetails}
                                                filterDisplay="row"
                                                scrollable
                                                sortField={filterReq.sortColumn}
                                                sortOrder={filterReq.sortOrder === "asce" ? 1 : -1}
                                                onSort={onTableSort}
                                                emptyMessage={"No named tracks found"}
                                            >
                                                <Column
                                                    field="trackerCode"
                                                    header="TRACK"
                                                    sortable
                                                    filter
                                                    showFilterMenu={false}
                                                    filterElement={trackFilterTemplate}
                                                    style={{ minWidth: "220px", }}
                                                />
                                                <Column
                                                    field="name"
                                                    header="NAME"
                                                    sortable
                                                    filter
                                                    showFilterMenu={false}
                                                    filterElement={nameFilterTemplate}
                                                    style={{ minWidth: "220px", }}
                                                />
                                                <Column
                                                    field="masterTrackerCode"
                                                    header="MASTER TRACK"
                                                    filter
                                                    showFilterMenu={false}
                                                    filterElement={masterTrackerFilterTemplate}
                                                    style={{ minWidth: "200px", }}
                                                />
                                                <Column
                                                    field="membersDisplay"
                                                    header="MEMBERS (ORDERED)"
                                                    body={membersBodyTemplate}
                                                    style={{ minWidth: "320px", }}
                                                />
                                                <Column
                                                    field="isActive"
                                                    header="STATUS"
                                                    sortable
                                                    body={statusBodyTemplate}
                                                    filter
                                                    filterField="isActive"
                                                    showFilterMenu={false}
                                                    filterElement={statusRowFilterTemplate}
                                                    style={{ minWidth: "220px", }}
                                                />
                                                <Column
                                                    field="createdAt"
                                                    header="Date Created"
                                                    sortable
                                                    body={(rowData: NamedTrackDetailsEntity) =>
                                                        rowData.createdAt
                                                            ? new Date(rowData.createdAt).toLocaleDateString("en-GB")
                                                            : "-"
                                                    }
                                                    style={{ minWidth: "200px" }}
                                                />
                                                {
                                                    (
                                                        checkActionAuthorization("update", "Name Track") || checkActionAuthorization("delete", "Name Track")) && (
                                                        <Column
                                                            header="Action"
                                                            body={actionIconTemplate}
                                                            style={{ minWidth: "180px", }}
                                                        />
                                                    )
                                                }
                                            </DataTable>
                                        </div>
                                    </div>
                                    {
                                        !IsNullOrEmptyArray(namedTrackDetails) && (
                                            <div className="mt-3">
                                                <PrimePaginator
                                                    onPageChange={onPageChange}
                                                    pageNumber={filterReq.pageNumber}
                                                    pageSize={filterReq.pageSize}
                                                    totalRecords={totalPageCount}
                                                />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                header={isEditMode ? "Edit Named Track" : "Add Named Track"}
                className="production-master-dialog"
                contentStyle={{ paddingBottom: "10px", }}
                resizable={false}
                draggable={false}
                visible={isDialogVisible}
                style={{ width: "520px", }}
                modal
                onHide={closeDialog}
                footer={<div className="d-flex justify-content-end gap-2">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={closeDialog}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSaveNamedTrack}
                    >
                        {isEditMode ? "Update" : "Save"}
                    </button>
                </div>
                }
            >
                <div className="row mt-3">
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>
                                TRACK CODE{" "}
                                <sup className="mandatory">*</sup>
                            </label>
                            <InputText
                                id="namedTrackCode"
                                value={trackCode}
                                maxLength={25}
                                className="form-control"
                                placeholder="Enter track code"
                                onChange={(e) => handleChange("code", e.target.value)}
                            />
                            {submitted && (
                                <small className="text-danger font-weight-500">
                                    {formErrors.code}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group mb-3">
                            <label>
                                MASTER TRACK{" "}
                                <sup className="mandatory">*</sup>
                            </label>
                            <Dropdown
                                value={selectedMasterTrackId}
                                options={masterTrackOptions}
                                optionLabel="label"
                                optionValue="value"
                                placeholder="Select master track"
                                className="w-100"
                                onChange={(e: DropdownChangeEvent) => handleMasterTrackChange(e.value)}
                            />
                            {submitted && (
                                <small className="text-danger font-weight-500">
                                    {formErrors.masterTrack}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group mb-3">
                            <label>
                                TRACK NAME{" "}
                                <sup className="mandatory">*</sup>
                            </label>
                            <InputText
                                id="namedTrackName"
                                value={trackName}
                                maxLength={50}
                                className="form-control"
                                placeholder="Enter track name"
                                onChange={(e) => handleChange("name", e.target.value)}
                            />
                            {submitted && (
                                <small className="text-danger font-weight-500">
                                    {formErrors.name}
                                </small>
                            )}
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group mb-3">
                            <label>
                                MEMBERS — ORDERED SET OF WORK CENTRES / TRACKS{" "}
                                <sup className="mandatory">*</sup>
                            </label>

                            {!IsNullOrEmptyArray(selectedMembers) && (
                                <div className="d-flex flex-wrap align-items-center gap-1 mt-1 mb-2">
                                    {selectedMembers.map((member, index) => (
                                        <React.Fragment key={`${member.categoryId}-${index}`}>
                                            <div
                                                className="d-flex align-items-center border rounded px-2 py-1"
                                                style={{ fontSize: "13px", background: "#f8f9fa", }}
                                            >
                                                <span>
                                                    {memberLabelMap.get(member.categoryId) || member.categoryId}
                                                </span>
                                                <span
                                                    className="text-danger cursor-pointer ms-2"
                                                    style={{ fontSize: "17px", lineHeight: "15px", }}
                                                    onClick={() => removeMember(index)}
                                                >
                                                    ×
                                                </span>
                                            </div>
                                            {index < selectedMembers.length - 1 && (
                                                <span className="text-muted">→</span>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>
                            )}

                            <div className="d-flex align-items-center gap-2">
                                <Dropdown
                                    value={memberToAdd}
                                    options={memberGroups}
                                    optionLabel="label"
                                    optionValue="value"
                                    optionGroupLabel="label"
                                    optionGroupChildren="items"
                                    placeholder=" Select Work Centres / Tracks."
                                    className="w-100"
                                    filter
                                    disabled={IsStringNullEmptyOrUndefined(selectedMasterTrackId)}
                                    emptyMessage="No members available"
                                    onChange={(e: DropdownChangeEvent) => setMemberToAdd(e.value)}
                                />
                                <button
                                    type="button"
                                    className="btn btn-primary btn-md font-weight-medium text-nowrap m-0"
                                    style={{ height: "42px", }}
                                    onClick={addMember}
                                    disabled={IsStringNullEmptyOrUndefined(memberToAdd)}
                                >
                                    + Add member
                                </button>
                            </div>
                            {submitted && (
                                <small className="text-danger font-weight-500">
                                    {formErrors.members}
                                </small>
                            )}
                            <div
                                className="mt-1"
                                style={{ color: "#9aa5b5", fontSize: "12px", }}
                            >
                                A track cannot contain itself — the save guard checks nesting.
                            </div>
                        </div>
                    </div>
                    {isEditMode && (
                        <div className="col-md-6">
                            <div className="form-group mb-3">
                                <label>STATUS</label>

                                <div className="d-flex align-items-center mt-2">
                                    {Status.map(
                                        (option: any) => (
                                            <div
                                                key={option.code}
                                                className="d-flex align-items-center me-4"
                                            >
                                                <RadioButton
                                                    inputId={String(option.code)}
                                                    name="status"
                                                    className="me-2"
                                                    value={option.code}
                                                    onChange={(e) => setNamedTrackIsActive(e.value)}
                                                    checked={namedTrackIsActive === option.code}
                                                />

                                                <label htmlFor={String(option.code)}>  {option.name}</label>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </Dialog>
        </>
    );
}

export default NamedTrack;
